module.exports = __webpack_public_path__ + "img/ko_img4.9951e44c.png";